import React, { Dispatch, SetStateAction, useContext, useState } from "react";
import "./style.scss";
import CustomButton from "../../../CustomButton/CustomButton";
import { raiseDiscountRequest } from "../../../../api/quotation.api";
import SnackbarContext from "../../../../context/snackbar.context";

interface DiscountSectionProp {
  quotationId: string;
  quotationStatus: string;
  tempQuotationStatus: string;
  totalPrice: number;
  quotationDiscount: any;
  tempQuotationDiscount: number;
  setTempDiscountObj: Dispatch<SetStateAction<any>>;
}

const DiscountSection: React.FC<DiscountSectionProp> = (props) => {
  const { totalPrice, quotationId, quotationStatus, tempQuotationStatus, quotationDiscount, tempQuotationDiscount, setTempDiscountObj } = props;
  const snackbarCtx = useContext(SnackbarContext);
  const [payloadObj, setPayloadObj] = useState({ quotationId: quotationId, discountAmount: 0, requestRemarks: "" });

  const handleDiscountChange = (e: any) => {
    const { value } = e.target;
    if (Number(value) < totalPrice) setPayloadObj((prevPayload) => ({ ...prevPayload, discountAmount: Number(value) }));
    else setPayloadObj((prevPayload) => ({ ...prevPayload, discountAmount: totalPrice }));
  };

  const handleRemarksChange = (e: any) => {
    const { value } = e.target;
    setPayloadObj((prevPayload) => ({ ...prevPayload, requestRemarks: value }));
  };

  const handleReqDiscountClick = async () => {
    const data = await raiseDiscountRequest(payloadObj);
    if (data.status === 201) {
      snackbarCtx.toggleSnackbar({
        message: data?.result,
        type: "SUCCESS",
        visible: true,
      });
      setTempDiscountObj({ tempQuotationStatus: 'PENDING', tempQuotationDiscount: payloadObj.discountAmount });
      setPayloadObj({ quotationId: quotationId, discountAmount: 0, requestRemarks: "" });
    } else {
      snackbarCtx.toggleSnackbar({
        message: data?.response?.data?.message,
        type: "FAILURE",
        visible: true,
      });
    }
  };

  const handleDiscountDisable = () => {
    if (quotationStatus !== 'ACTIVE') return true;
    else {
      if (quotationDiscount && quotationDiscount?.status !== 'pending') return true;
      else return false;
    }
  }

  const numberInputOnWheelPreventChange = (e: any) => {
    e.target.blur();
    e.stopPropagation();
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  return (
    <section className="w-100 h-100 overflow-auto p-3 flex flex-col gap-2.5 modal-discount-section-wrapper">
      <div className="flex gap-2 flex-wrap">
        <span className="font-semibold text-2xl text-[#3a3a3a]">DISCOUNT SECTION</span>
        {(quotationDiscount || tempQuotationStatus) && <div className="alert alert-warning m-0 py-0" role="alert">
          <span className="my-auto text-xs" >DISCOUNT: ₹ { tempQuotationDiscount || quotationDiscount?.discountAmount}  &nbsp; STATUS: { tempQuotationStatus || quotationDiscount?.status?.toUpperCase()}</span>
        </div>}
      </div>
      <div className="flex flex-col gap-1.5 discount-input-wrapper">
        <label htmlFor="discount-input">Enter Discount</label>
        <div>
          <span>₹</span>
          <input
            type="number"
            value={payloadObj.discountAmount || ""}
            name="discount-input"
            id="discount-input"
            placeholder="Discount Amount"
            onWheel={numberInputOnWheelPreventChange}
            onChange={handleDiscountChange}
            disabled={handleDiscountDisable()}
          />
        </div>
      </div>
      <div className="flex flex-col gap-2 mt-2 discount-textarea-wrapper">
        <label htmlFor="remarks">Add Remarks</label>
        <textarea
          name="remarks"
          id="reamrks"
          className="w-100 min-h-[60px]"
          placeholder="Remarks"
          value={payloadObj?.requestRemarks}
          onChange={handleRemarksChange}
          disabled={handleDiscountDisable()}
        ></textarea>
      </div>
      <CustomButton
        clx="self-end mt-2"
        onButtonClick={handleReqDiscountClick}
        disabled={true}
        // disabled={!payloadObj?.discountAmount || !payloadObj?.requestRemarks?.trim()}
      >
        Request Discount
      </CustomButton>
    </section>
  );
};

export default DiscountSection;
